import { DeliveryCompanyFormValues } from "../deliveryCompanies.types";

export const EMPTY_DELIVERY_COMPANY_FORM_VALUES: DeliveryCompanyFormValues = {
  name: "",
  email: "",
  password: "",
  repeatPassword: "",
  capacity: "",
  phoneNumber: "",
  address: "",
  avatarMediaId: null
};

export const DELIVERY_COMPANY_STATUSES_LIST = [
  { label: "Active", value: true, backgroundColor: "#16C350" },
  { label: "Inactive", value: false, backgroundColor: "#A8A8BB" }
];

export enum ApiRoutesDeliveryCompanies {
  Companies = "/admin/delivery-companies",
  CompaniesAll = "/admin/delivery-companies/all",
  CompaniesOne = "/admin/delivery-companies/one",
  CompaniesActive = "/admin/delivery-companies/active",
  CompaniesReorder = "/admin/delivery-companies/reorder"
}
